<template>
  <div>
    <div
      style="
        margin-inline-start: -12px;
        width: calc(100% + 24px);
        background: #ecf8f655;
        box-shadow: 0px 2px 4px 0px #00000011;
      "
    >
      <div style="padding-right: 8px">
        <apexchart
          height="182"
          :options="chartOptions"
          :series="series"
        ></apexchart>
      </div>
      <div style="height: 16px; background-color: white"></div>
    </div>
  </div>
</template>

<script lang="js">
import Vue from "vue";
import { Component } from "vue-property-decorator";
import VueApexCharts from 'vue-apexcharts'
import { Prop } from "vue-property-decorator";

@Component({
  components: {
    VueApexCharts
  },
})
export default class Utilities extends Vue {
  @Prop() chartdata;
  chartOptions = {
    chart: {
      type: 'area',
    },
  };
  series = [];
  mounted() {
    setTimeout(() => {
      this.series = [
        { data: this.chartdata.series.map(e => parseFloat((""+e).replace("e+")).toFixed(2) ?? 0) ?? [] }
      ]
      this.chartOptions = {
        chart: {
          type: 'area',
          toolbar: {
            show: false,
          },
        },
        dataLabels: {
          enabled: false
        },
        colors: ['#00957A'],
        xaxis: {
          categories: this.chartdata.labels ?? [],
          labels: {
            style: {
              fontSize: '8px'
            }
          }
        },
        yaxis: {
          labels: {
            style: {
              fontSize: '8px'
            }
          },
        },
        stroke: {
          width: 1
        }
      };
    }, 2000);
  }


}
</script>
